<template>
    <font-awesome-icon class="text-red-500" icon="fa-exclamation-circle" />
    Error
</template>
